import React, { useState } from "react";
import WSProgressBar from "../../Workspace2/WSProgressBar";
import "../../Workspace2/sidebar.css";
// import Button from "@mui/material/Button";
import { motion } from "framer-motion";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation, useParams } from "react-router";
import { addworkspaceteamMember, createWorkspaceName, getWorkspace } from "../ApiServices/apiHandler";
import WorkspaceHeader from "./WorkspaceHeader";
import swal from "sweetalert";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { Button } from "../../../myfin_v2/elements/Button"


const WorkspaceSetup = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { beckFrom } = useSelector((state) => state.AllWSReducer);

  const [workspaceName, setWorkspaceName] = useState("");
  const [workspace, setWorkspace] = useState("");
  const [oneworkspace, setOneWorkspace] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    getWorkspaceDetails();
  }, [])
  const handleChange = (e) => {
    const { value } = e.target;
    setWorkspaceName(value);
    setHasChanged(true);
    if (value === workspace) {
      dispatch({ type: "WS_BACK_FROM_QUERY", payload: "addCompanies" });
    } else {
      dispatch({ type: "WS_BACK_FROM_QUERY", payload: null });
    }
  };
  const handleSave = async () => {
    if (workspaceName === "" && workspace === "") {
      return swal("Warning", "Please Enter Workspace Name", "warning")
    }
    const data = {
      workspaceName: workspaceName ? workspaceName : workspace,
      steps: "step2",
      has_published: "draft",
      status: oneworkspace.status
    };
    if (beckFrom === "addCompanies") {
      history.push(`/addCompanies/${id}`);
    } else if (user.responsibilities === "approver") {
      history.push(`/addCompanies/${id}`);
    } else if (hasChanged === false) {
      history.push(`/addCompanies/${id}`);
    }
    else {
      createWorkspaceName(id, data).then(res => {
        const datas = {
          workspace_id: id,
          user_id: user._id
        };
        addworkspaceteamMember(datas).then(res => {
          history.push(`/addCompanies/${id}`);
        }).catch(error => {
          swal("Error", "Workspace Team creation Failed", "error")
        });
      }).catch(error => {
        swal("Error", error.response.data.error || "Please Enter Workspace Name", "error")
      });
    }
  };

  const getWorkspaceDetails = async () => {
    const res = await getWorkspace(id);
    if (res.status === 200) {
      setWorkspace(res.data.getworkspace[0].workspace_name)
      setOneWorkspace(res.data.getworkspace[0]);
    }
  }

  return (
    <>
      <div  className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div >
          <WSProgressBar activePage={2} id={id} />
        </div>
        <motion.div
        initial={{ x: 500, y: 500, opacity: 0 }}
        animate={{ x: 0, y: 0, opacity: 1 }}
        exit={{ x: 0, y: 0, opacity: 0 }}
        transition={{ duration: 0.7, ease: "easeInOut" }} className={wsCreationcss.wsCrtNameDiv}>
          <span className={wsCreationcss.wsCreationCatHeading}>
            Give your workspace a name to get started!
          </span>
          <span>
            <div className={`${commoncss.inputCol}`} style={{ "margin-top": "36px" }}>
              <input
                style={{ width: "450px" }}
                placeholder="Workspace Name here"
                // className="wp-setup-form-input"
                type="text"
                disabled={user.responsibilities === "approver" || oneworkspace.status === "waiting" || user.responsibilities === "view"}
                defaultValue={workspace ? workspace : workspaceName}
                onChange={handleChange}
              />
            </div>
          </span>
          {/* <div className="row mt-3">
            <div className="col-md-12">
              <div className="wp-setup-form-label"> Name of your workspace{" "}
                <span style={{ color: "red" }}>*</span></div>

              <div className="inputbox">
                <input
                  style={{ height: "50px" }}
                  className="wp-setup-form-input"
                  type="text"
                  disabled={user.responsibilities === "approver" || oneworkspace.status === "waiting" || user.responsibilities === "view"}
                  defaultValue={workspace ? workspace : workspaceName}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div> */}

        </motion.div>
        <div className={wsCreationcss.footerContainer}>
          <div>
            <button
              onClick={() => history.push(`/dashboard`)}
              className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
          </div>
          <div className={wsCreationcss.footerbtnContainer}>
            <button
              className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
              onClick={() => history.push(`/workspacelayout/${id}`)}
            ><PervBtnIcon height={19} />Previous</button>
            {workspaceName || workspace ? (
              <button onClick={handleSave} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Next<RightIcon height={12} /></button>
            ) : (
              <button className={wsCreationcss.saveBtn} type="button" disabled style={{ "padding": "7px" }}>Next &nbsp;<RightIcon /></button>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default WorkspaceSetup;
